const element = document.querySelector('nav .news_sections');
const alert_class = 'sticky';
const alert_trigger = 0;

function element_position_tracker(element, element_original_position, alert_class, alert_trigger) {
  if( element_original_position < window.pageYOffset ) {
    element.classList.add(alert_class);
  } else {
    element.classList.remove(alert_class);
  }
}

function sticky_header() {
  const element_original_position = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
  window.addEventListener('scroll', function(e) {
    element_position_tracker(element, element_original_position, alert_class, alert_trigger);
  });
}

sticky_header();
